import {
  CardActivityType,
  MULTIPLE_CHOICE_CARD_ACTIVITY_TYPES,
  REPEAT_CARD_ACTIVITY_TYPES,
  RESPOND_CARD_ACTIVITY_TYPES,
  SHORT_ANSWER_CARD_ACTIVITY_TYPES,
} from '@/models/card-activity/card-activity.model'

export const checkTypeCardActivity = (type: CardActivityType | undefined) => {
  if (!type)
    return {
      isRepeat: false,
      isRespond: false,
      isMC: false,
      isShortAnswer: false,
    }

  return {
    isRepeat: checkIsRepeatCard(type),
    isRespond: checkIsRespondCard(type),
    isShortAnswer: checkIsShortAnswerCard(type),
    isMC: checkIsMCCard(type),
    isMediaPage: checkIsMediaPage(type),
  }
}

export const checkIsRepeatCard = (type: CardActivityType | undefined) => {
  if (!type) return false

  return REPEAT_CARD_ACTIVITY_TYPES.includes(type)
}

export const checkIsRespondCard = (type: CardActivityType | undefined) => {
  if (!type) return false

  return RESPOND_CARD_ACTIVITY_TYPES.includes(type)
}

export const checkIsShortAnswerCard = (type: CardActivityType | undefined) => {
  if (!type) return false

  return SHORT_ANSWER_CARD_ACTIVITY_TYPES.includes(type)
}

export const checkIsMCCard = (type: CardActivityType | undefined) => {
  if (!type) return false

  return MULTIPLE_CHOICE_CARD_ACTIVITY_TYPES.includes(type)
}

export const checkIsMediaPage = (type: CardActivityType | undefined) => {
  if (!type) return false

  return type === CardActivityType.MEDIA_PAGE
}
